import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms'

export function controlValueEqualValidator(targetControl: any) {
  return (control: AbstractControl): ValidationErrors | null => {
    return targetControl.value === control.value
      ? null
      : { valueNotEqual: true }
  }
}

export function passwordPatternValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\p{P}\p{S}]).{8,}$/u
    return control.value && pattern.test(control.value)
      ? null
      : { passwordPattern: true }
  }
}
